/**
 * User-facing copy for the external coaching booking (hubspot-off-block-3
 * task 64). afy-ui has no i18n library, so every string lives here instead of
 * inline in the components.
 */
const strings = {
  iframeTitle: 'Book your coaching call',
  continueButton: 'I booked my call — continue',
  continuePending: 'Confirming…',
  continueError:
    'We could not confirm your booking. Please try again. If the problem persists, contact our support team.',
  unavailableTitle: 'Our coaching calendar is not available right now',
  unavailableMessage: ({ email, phone } = {}) => {
    const contacts = [email, phone].filter(Boolean).join(' or ');
    return contacts
      ? `Please contact our support team at ${contacts} to book your coaching call.`
      : 'Please contact our support team to book your coaching call.';
  },
};

export default strings;
